<template>
  <div class="comoon_edit_frame mb-24" >
    <div class="tab" v-if="$route.query.type == 'imageText'">
        <el-button  :type="activeName === '1'?'primary':'secondary'" size="small" @click="setSelect('1')">单个职位</el-button>
        <el-button  :type="activeName === '2'?'primary':'secondary'"  size="small" @click="setSelect('2')" >多个职位</el-button>
    </div>
    <div class="tips" v-if="activeName === '2' && $route.query.type == 'imageText'">
        <el-alert
        type="warning"
        show-icon
        :closable="false"
        >
            多个职位下不展示职位信息
        </el-alert>
    </div>
    <template v-if="type === 'module'">
        <div class="title " :class="$route.query.type == 'imageText'?'mt-24':''">排列</div>
            <div class="sort fx">
                <span @click="move('up')">
                    <el-tooltip
                    class="item"
                    content="上移一层"
                    placement="top"
                    >
                       <i class="iconfont icon icon-shangyiyiceng"></i>
                    </el-tooltip>
                </span>
                <span @click="move('down')">
                    <el-tooltip
                    class="item"
                    content="下移一层"
                    placement="top"
                    >
                        <i class="iconfont icon icon-xiayiyiceng"></i>
                    </el-tooltip>
                </span>
                <span @click="move('top')">
                    <el-tooltip
                    class="item"
                    content="置于顶部"
                    placement="top"
                    >
                        <i class="iconfont icon icon-zhixudingbu"></i>
                    </el-tooltip>
                </span>
                <span @click="move('bottom')">
                    <el-tooltip
                    class="item"
                    content="置于底部"
                    placement="top"
                    >
                        <i class="iconfont icon icon-zhixudibu"></i>
                    </el-tooltip>
                </span>
            </div>
            <div class="position fx mt-16" v-if="!['jobResponsibility','qualifications','positionInfo','jobResponsibilityTitle','qualificationsTitle'].includes(module.textType)">
                <el-input-number
                v-model="module.style.left"
                controls-position="right"
                placeholder="请输入"
                size="medium"
                class="mr-20"
                :key="1"
                :controls="false"
                >
                    <el-input
                        slot="prepend"
                        value="X"
                        readonly
                        class="prepend-box"
                    >
                    </el-input>
                </el-input-number>
                <el-input-number
                v-model="module.style.top"
                controls-position="right"
                placeholder="请输入"
                size="medium"
                :key="2"
                :controls="false"
                >
                    <el-input
                        slot="prepend"
                        value="Y"
                        readonly
                        class="prepend-box"
                    >
                    </el-input>
                </el-input-number>
            </div>
            <div class="roate roat3 fx mt-16" v-if="!['jobResponsibility','qualifications','positionInfo','jobResponsibilityTitle','qualificationsTitle'].includes(module.textType)">
                <el-input-number
                v-model="module.style.width"
                controls-position="right"
                placeholder="请输入"
                size="medium"
                class="mr-12"
                :key="3"
                :controls="false"
                >
                    <el-input
                        slot="prepend"
                        value="宽"
                        readonly
                        class="prepend-box"
                    >
                    </el-input>
                </el-input-number>
                <el-input-number
                v-model="module.style.height"
                controls-position="right"
                placeholder="请输入"
                size="medium"
                :key="4"
                class="mr-12"
                :controls="false"
                >
                    <el-input
                        slot="prepend"
                        value="高"
                        readonly
                        class="prepend-box"
                    >
                    </el-input>
                </el-input-number>
                <my_rotate :value.sync="module.style.rotate" class="mr-12"/>
            </div>
    </template>
    <template v-else>
        <div class="title mt-24">海报尺寸</div>
        <div class="subtitle" v-if="$route.query.type == 'detail'">宽度</div>
        <div class="roate fx mt-16">
            <el-input-number
            v-model="$store.state.body.data.width"
            :min="1"
            :max="670"
            controls-position="right"
            placeholder="请输入"
            size="medium"
            class="mr-12"
            :controls="false"
            :disabled="$route.query.type == 'detail'"
            >
                <el-input
                    slot="prepend"
                    value="宽"
                    readonly
                    class="prepend-box"
                >
                </el-input>
            </el-input-number>
            <!-- <el-input
            size="medium"
            placeholder="请输入"
            v-model="$store.state.body.data.width"
            key="3"
            class="mr-12"
            >

            </el-input> -->
            <!-- <el-input
            size="medium"
            placeholder="请输入"
            v-model="$store.state.body.data.height"
            key="4"
            class="mr-12"
            >
                <el-input
                    slot="prepend"
                    value="高"
                    readonly
                    class="prepend-box"
                    type="number"
                >
                </el-input>
            </el-input> -->
            <el-input-number
            v-if="$route.query.type != 'detail'"
            v-model="$store.state.body.data.height"
            :min="1"
            :max="1192"
            controls-position="right"
            placeholder="请输入"
            size="medium"
            :controls="false"
            >
            <!-- <span slot="prefix" class="el-input__text">高</span> -->
                <el-input
                    slot="prepend"
                    value="高"
                    readonly
                    class="prepend-box"
                >
                </el-input>
            </el-input-number>
        </div>
        <div class="subtitle">高度</div>
        <div class="roate fx mt-16" v-if="$route.query.type == 'detail'">
            <el-input-number
            v-if="$store.state.body.data.pages.headerConfig"
            v-model="$store.state.body.data.pages.headerConfig.style.height"
            :min="1"
            :max="300"
            controls-position="right"
            placeholder="请输入"
            size="medium"
            class="mr-12"
            :controls="false"
            >
                <el-input
                    slot="prepend"
                    value="头部"
                    readonly
                    class="prepend-box"
                >
                </el-input>
            </el-input-number>
            <el-input-number
            v-if="$store.state.body.data.pages.footerConfig"
            v-model="$store.state.body.data.pages.footerConfig.style.height"
            :min="1"
            :max="300"
            controls-position="right"
            placeholder="请输入"
            size="medium"
            :controls="false"
            >
            <!-- <span slot="prefix" class="el-input__text">高</span> -->
                <el-input
                    slot="prepend"
                    value="底部"
                    readonly
                    class="prepend-box"
                >
                </el-input>
            </el-input-number>
        </div>
    </template>
  </div>
</template>

<script>
import my_rotate from '../my_rotate'
export default {
  name: 'CommonEdit',
  components: {
    my_rotate
  },
  data() {
    return {
      input: ''
    }
  },
  props: {
    // 是否处于多选状态
    multiple: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'module'
    }
  },
  computed: {
    module() {
      return this.$store.state.widgets.module_Data
    },
    activeName() {
      return this.$store.state.body.data.selectPosition
    },
    widgets() {
      return this.templet.get_widgets()
    }
  },
  methods: {
    setSelect(type) {
      this.$store.commit('body/setSelectPosition', type)
      this.changeWidgets()
    },
    changeWidgets() {
      // 根据选择的职位数量设置对应挂件展示
      this.widgets.map(widgets => {
        if (this.activeName === '1') {
          if (widgets.textType === 'positionName') widgets.text = '系统预设职位'
          if (widgets.textType === 'positionInfo') widgets.style.opacity = 1
        } else {
          if (widgets.textType === 'positionName') widgets.text = '系统预设职位系统预设职位等三个职位'
          if (widgets.textType === 'positionInfo') widgets.style.opacity = 0
        }
      })
    },
    on_click_tab() {},
    move(type) {
      this.templet.move_layer(type)
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.fx{
    display: flex;
}
.tips{
    padding:16px 16px 0 0px;
    .el-alert{
        width: 100%;
    }
}
.comoon_edit_frame {
  .title{
    font-size: 14px;
    color: #1D2129;
    font-weight: 500;
    line-height: 40px;
    border-bottom: #F2F3F5  solid 1px ;
  }
  .subtitle{
    color: #4E5969;
    font-size: 14px;
    margin-top: 20px;
  }
  .sort{
    border: #E5E6EB solid 1px;
    border-radius: 2px;
    overflow: hidden;
    line-height: 32px;
    width: 100%;
    margin-top: 21px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    span{
        flex: 1;
        &:not(:last-child){
            border-right: #E5E6EB solid 1px;
        }
        .icon{
            font-size: 18px;
            color: #4E5969;
        }
    }
  }
  ::v-deep{
    .roate{
        height: 32px;
        display: flex;
        .el-input-group{
            width: 115px;
            height: 32px;
            .el-input-group__prepend+.el-input__inner{
                text-align: center;
                padding-left: 5px;
            }
            .el-input-number{
                width: 83px;
            }
        }
        &.roat3{
            .el-input-group{
                width: 94px;
            }
        }
    }

    .el-input-group__prepend+.el-input__inner{
        text-align: center;
        padding-top:0;
    }
    .el-input-group__prepend {
        height: 100%;
        .el-input__inner{
            width: 32px;
            padding: 0;
            text-align: center;
        }
    }
    .el-input__wrap--append .el-input__inner{
        border-right: none;
    }
    .el-input-group__append .el-input__inner{
        padding: 0;
        width: 10px;
        border-left: none;
    }
    .my-num-symbol{
        top:0;
    }
  }
}
</style>
